var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M13.3 32.7h.1c-1.8 0-3.1-.8-3.1-2.6V16.7h6v13.4c0 1.8-1.3 2.6-3 2.6zM13.4 8.3l-3.2 6.4h6.4zM28.6 8.7v6h-4.5v-6c-2.4.9-4 3.2-4 5.9 0 2.6 1.6 4.8 3.8 5.8v9.9c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5v-9.9c2.2-1 3.8-3.2 3.8-5.8-.1-2.7-1.8-5-4.1-5.9z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Tools.svg